window.addEventListener('DOMContentLoaded', () => {
  const showSizeGuide = new URLSearchParams(window.location.search).get('sizeguide')

  if (showSizeGuide !== null) {
    triggerSizeGuide(null, 'sizing-guide-modal')
  }

  document.body.addEventListener('click', (eventClick) => {
    triggerSizeGuide(eventClick, null)
  })

  function triggerSizeGuide (eventClick, openModalManual) {
    const theModalID = document.getElementById('sizingGuideModal')
    const bodyClass = document.querySelector('body')
    const theTriggersAttributeValue = 'sizing-guide-modal'
    const modalInner = document.getElementById('global__popup__modal__overlay')

    let openModal = ''
    let closeModal = ''
    let clickInside = ''

    if (eventClick) {
      openModal = eventClick.target.getAttribute('global_popup_modal_open')
      closeModal = eventClick.target.getAttribute('global_popup_modal_close')
      clickInside = modalInner.id === eventClick.target.id
    } else {
      openModal = openModalManual
    }

    if (openModal === theTriggersAttributeValue) {
      theModalID.style.zIndex = 1000
      theModalID.classList.add('global__popup-modal--show')
      theModalID.classList.remove('global__popup-modal--hide')
      bodyClass.classList.toggle('is-modal-open')

      window.BAO.Utils.pushToDataLayer('size_guide_open')
    }

    if (closeModal === theTriggersAttributeValue) {
      theModalID.classList.remove('global__popup-modal--show')
      theModalID.classList.add('global__popup-modal--hide')
      bodyClass.classList.toggle('is-modal-open')
    }

    // close modal from anywhere outside
    if (clickInside) {
      theModalID.classList.remove('global__popup-modal--show')
      theModalID.classList.add('global__popup-modal--hide')
      bodyClass.classList.toggle('is-modal-open')
    }
  }
})
